import { ToastOptions, TypeOptions } from 'react-toastify';

const CommonConfig: ToastOptions = {
  autoClose: 1500,
  style: { fontSize: 'small' },
  theme: 'light',
};

type ToastConfigModel = Record<TypeOptions, ToastOptions>;

export const ToastConfig: ToastConfigModel = {
  default: {
    ...CommonConfig,
    type: 'default',
  },
  error: {
    ...CommonConfig,
    autoClose: false,
    closeOnClick: true,
    draggable: false,
    type: 'error',
  },
  info: {
    ...CommonConfig,
    type: 'info',
  },
  success: {
    ...CommonConfig,
    type: 'success',
  },
  warning: {
    ...CommonConfig,
    type: 'warning',
  },
};
